<template>
	<div>
		<SanityHtmlCard :data="data" />
	</div>
</template>
<script setup lang="ts">
	import type {PropType} from 'vue';
	import SanityHtmlCard from '~/components/html-pages/SanityHtmlCard.server.vue';
	import type {MinimalSanityHelpPage} from '~/lib/types/helpPagesTypes';

	defineProps({
		data: {
			type: Object as PropType<MinimalSanityHelpPage>,
			required: true
		}
	});
</script>
